import React from "react";
import { Box } from "@mui/material";
import { Token } from "../../theme";

export const missingDaysSeverity = (missingDays: number) => {
  if (missingDays > 1) return { fg: Token.statusDangerFg, bg: Token.statusDangerBg };
  if (missingDays === 1) return { fg: Token.statusWarningFg, bg: Token.statusWarningBg };
  return { fg: Token.statusSuccessFg, bg: Token.statusSuccessBg };
};

const BAR_WIDTH = 64;
const MAX_SCALE = 5;

export const MissingDaysCell: React.FC<{ missingDays: number }> = ({ missingDays }) => {
  if (missingDays < 0) {
    return <span style={{ fontSize: 12.5, color: Token.textSecondary }}>{`Extra days + ${-missingDays}`}</span>;
  }

  const { fg, bg } = missingDaysSeverity(missingDays);
  const filled = Math.round((Math.min(missingDays, MAX_SCALE) / MAX_SCALE) * BAR_WIDTH);

  return (
    <Box display="flex" alignItems="center" style={{ gap: 8 }}>
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          minWidth: 20,
          height: 20,
          borderRadius: 3,
          padding: "0 6px",
          fontFamily: "var(--font-mono)",
          fontVariantNumeric: "tabular-nums",
          fontSize: 11,
          fontWeight: 600,
          color: fg,
          background: bg,
        }}
      >
        {missingDays}
      </span>
      <span
        style={{
          display: "inline-block",
          width: BAR_WIDTH,
          height: 4,
          borderRadius: 999,
          background: Token.borderSubtle,
          position: "relative",
        }}
      >
        <span
          style={{
            position: "absolute",
            left: 0,
            top: 0,
            height: 4,
            width: filled,
            borderRadius: 999,
            background: fg,
          }}
        />
      </span>
    </Box>
  );
};
